<template>
  <header class="header" @click="handleHeaderClick">
    <!-- Logo and desktop menu -->
    <RouterLink to="/" class="logo-link" @click.prevent="handleLogoClick">
      <p>EVGENIY PAVLOV</p>
    </RouterLink>
    <div class="segment">
      <p>KHARKIV UKRAINE</p>
      <p>1949 – ONGOING</p>
      <p>1972-2004 YEARS ACTIVE</p>
      <p>24 SERIES</p>
    </div>

    <!-- Default menu for desktop -->
    <nav class="default-menu">
      <ul>
        <li><RouterLink to="/info">INFO</RouterLink></li>
        <li><RouterLink to="/archive">INDEX</RouterLink></li>
<!--        <li><RouterLink to="/press">PRESS</RouterLink></li>-->
        <li><RouterLink to="/contact">CONTACT</RouterLink></li>
      </ul>
    </nav>

    <!-- Burger menu button for mobile -->
    <button class="burger-menu" @click="toggleMenu">MENU</button>

    <!-- Mobile overlay menu -->
    <div v-if="isMenuActive" class="menu-overlay">
      <RouterLink to="/" class="overlay-logo-link" @click="hideMenu">EVGENIY PAVLOV</RouterLink>
      <button class="close-menu" @click="hideMenu">CLOSE</button>
      <ul>
        <li><RouterLink to="/info" @click="hideMenu">Info</RouterLink></li>
        <li><RouterLink to="/archive" @click="hideMenu">Index</RouterLink></li>
<!--        <li><RouterLink to="/press" @click="hideMenu">Press</RouterLink></li>-->
        <li><RouterLink to="/contact" @click="hideMenu">Contact</RouterLink></li>
      </ul>
      <div class="bottom-links">
        <a href="https://www.instagram.com/evgeniy.pavlov.photography/" target="_blank">INSTAGRAM</a>
      </div>
    </div>
  </header>
</template>

<script setup>
import {ref, onMounted, onBeforeUnmount} from 'vue';
import {useRouter} from 'vue-router';
import {useModalState} from '@/hooks/useModalState';

const router = useRouter();
const {isModalActive} = useModalState();
const isMenuActive = ref(false);

const toggleMenu = () => {
  isMenuActive.value = !isMenuActive.value;
};

const handleHeaderClick = (event) => {
  // If it's a link, do nothing
  const clickedLink = event.target.closest('a');
  if (clickedLink) return;

  const galleryContainer = document.querySelector('.projects-container');
  if (galleryContainer) {
    galleryContainer.dispatchEvent(new KeyboardEvent('keydown', {
      key: 'Escape',
      bubbles: true
    }));
  }
};

const handleLogoClick = (event) => {
  // Case 1: If burger menu is open, close it and navigate to home
  if (isMenuActive.value) {
    hideMenu();
    router.push('/');
    return;
  }

  // Check if gallery is expanded - we can use the class to determine this
  const expandedGallery = document.querySelector('.projects.expanded');

  if (expandedGallery) {
    // Case 2: Gallery is expanded, toggle it
    const galleryContainer = document.querySelector('.projects-container');
    if (galleryContainer) {
      galleryContainer.dispatchEvent(new KeyboardEvent('keydown', {
        key: 'Escape',
        bubbles: true
      }));
    }
  } else {
    // Case 3: Gallery is not expanded, just navigate to home
    router.push('/');
  }
};

const hideMenu = () => {
  isMenuActive.value = false;
};

const handleResize = () => {
  if (window.innerWidth > 768 && isMenuActive.value) {
    hideMenu();
  }
};

onMounted(() => {
  window.addEventListener('resize', handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});
</script>